"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function parseAmendment(tx) {
    return {
        amendment: tx.Amendment
    };
}
exports.default = parseAmendment;
//# sourceMappingURL=amendment.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ripple-lib/dist/npm/ledger/parse/amendment.js
// module id = rsvH
// module chunks = 0